import { render, staticRenderFns } from "./bannedCollect.vue?vue&type=template&id=3d034748&scoped=true"
import script from "./bannedCollect.vue?vue&type=script&lang=js"
export * from "./bannedCollect.vue?vue&type=script&lang=js"
import style0 from "./bannedCollect.vue?vue&type=style&index=0&id=3d034748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d034748",
  null
  
)

export default component.exports